(function () {
  if (window.__contactPageScriptLoaded) return;
  window.__contactPageScriptLoaded = true;

  var observer;

  function createObserver() {
    if (observer || !("IntersectionObserver" in window)) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.14,
        rootMargin: "0px 0px -8% 0px"
      }
    );
  }

  function initAnimations(root) {
    root = root || document;
    createObserver();

    var items = root.querySelectorAll("[data-contact-animate]");
    items.forEach(function (item) {
      if (item.dataset.contactBound === "true") return;
      item.dataset.contactBound = "true";

      if (observer) {
        observer.observe(item);
      } else {
        item.classList.add("is-visible");
      }
    });
  }

  function init(root) {
    initAnimations(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();